export const subscriptionIsValid = (subscription) => {
    if (!subscription) return false;

    const now = Math.round(Date.now() / 1000);
    return subscription.starts_at < now && subscription.expires_at > now && subscription.active;
};

export const subscriptionIsCancelled = (subscription) => {
    return subscription && subscription.cancelled_at;
};
